// extracted by mini-css-extract-plugin
module.exports = {"SelectedOrderTypeTitleDiv":"styles_SelectedOrderTypeTitleDiv__sGjQJ","OrderTypeTitleDiv":"styles_OrderTypeTitleDiv__3KOt7"};